import { makeStyles } from '@material-ui/core/styles';

// Styles are based on the existing v4 sidebar/list styles
// but are scoped via Material-UI JSS classes so they do not
// conflict with the legacy implementation.

const styles = (theme) => ({
  // Sidebar container
  root: {
    marginTop: 16,
    width: 300,
    border: `1px solid ${theme.palette.borderColor.lightGrey}`,
    position: 'absolute',
    transition: 'transform 0.2s ease',
  },
  mobileAdminRoot: {
    width: '100%',
  },
  rootHidden: {
    transform: 'translateX(-98%)',
  },
  searchWrapper: {
    height: 50,
    padding: '10px 20px 10px 10px',
    position: 'relative',
  },
  search: {
    display: 'block',
    margin: 0,
    '& > div': {
      border: 'none',
    },
    '& input': {
      padding: 0,
      height: 30,
    },
  },
  searchIcon: {
    color: theme.palette.textColor.secondary,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toggleButton: {
    position: 'absolute',
    borderRadius: 50,
    width: 25,
    height: 25,
    border: '1px solid #A4A5B3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1011,
    transform: 'translate(50%, -50%)',
    right: 0,
    top: '50%',
    background: 'white',
    cursor: 'pointer',
    padding: 0,
    '&:hover': {
      background: '#F6F6F7',
    },
    '&:focus': {
      boxShadow:
        '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
      background: '#F6F6F7',
    },
  },

  // List / content styles (ported from ResourcesList styles)
  resourcesWrapper: {
    padding: '10px 15px 10px',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 1050px)': {
      height: 'calc(100vh - 268px)',
      overflow: 'auto',
    },
    '@media (min-width: 1051px)': {
      height: 'calc(100vh - 198px)',
      overflow: 'auto',
    },
  },
  flexColum: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    marginTop: 15,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
  },
  column: {
    verticalAlign: 'top',
    width: 126,
    '&:first-child': {
      marginRight: 8,
    },
  },
  marginBottom: {
    marginBottom: 8,
  },
  marginBottomBig: {
    marginBottom: 16,
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  username: {
    wordBreak: 'break-word',
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  day: {
    color: theme.palette.textColor.yellow,
  },
  night: {
    color: theme.palette.textColor.darkBlue,
  },
  inactive: {
    color: theme.palette.textColor.secondary,
  },
  equipmentBlock: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    maxWidth: '100%',
    height: 20,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
  },
  equipmentNumber: {
    padding: '3px 6px',
    borderRadius: 20,
    color: theme.palette.textColor.white,
    textAlign: 'center',
  },
  equipmentName: {
    marginLeft: '4px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'max-content',
  },
  itemWrapper: {
    padding: 3,
    border: `1px solid ${theme.palette.borderColor.white}`,
    backgroundColor: theme.palette.background.default,
    width: 'fit-content',
    maxWidth: 126,
  },
  usedResource: {
    opacity: 0.3,
  },
  unavailableItem: {
    pointerEvents: 'none',
    width: 'fit-content',
    '& > div': {
      backgroundColor: `${theme.palette.borderColor.lightGrey} !important`,
      maxWidth: 127,
      '& div': {
        color: theme.palette.textColor.white,
      },
    },
  },
  unavailableUser: {
    pointerEvents: 'none',
    borderColor: theme.palette.borderColor.lightGrey,
    width: 'fit-content',
    '& > div': {
      backgroundColor: `${theme.palette.borderColor.lightGrey} !important`,
      borderRadius: 17,
      width: 'fit-content',
      paddingRight: 5,
      maxWidth: 127,
      '& div': {
        borderColor: theme.palette.borderColor.lightGrey,
      },
      '& p': {
        color: theme.palette.textColor.white,
      },
    },
  },
  warning: {
    position: 'absolute',
    left: '-10px',
    top: '6px',
    cursor: 'pointer',
    '& svg': {
      width: 12,
      height: 12,
    },
  },
  warningEquip: {
    position: 'absolute',
    left: '-12px',
    top: '8px',
    cursor: 'pointer',
    '& svg': {
      width: 12,
      height: 12,
    },
  },
  resourceWrapper: {
    position: 'relative',
  },
  locationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover svg': {
      background: 'transparent',
      color: theme.palette.primary.blue,
    },
    '&:focus svg': {
      background: 'transparent',
      color: theme.palette.secondary.main,
    },
  },
  locationName: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'flex-start',
  },
  locationColorBox: {
    display: 'flex',
    width: '12px',
    height: '12px',
    borderRadius: '3px',
    marginRight: '4px',
  },
  expandButton: {
    minWidth: 24,
    height: '24px !important',
  },
  // Warning Icon
  passInfoBlock: {
    width: '260px',
    backgroundColor: '#575757',
    position: 'absolute',
    zIndex: '3',
    color: 'white',
    fontWeight: 'normal',
    textAlign: 'left',
    padding: '11px',
    borderRadius: '6px',
    top: '0',
    left: '20px',
    '@media (min-width: 999px)': {
      left: 'auto',
    },
  },
  passInfoIcon: {
    position: 'relative',
    '&:hover $passInfoBlock': {
      display: 'block',
    },
  },
});

export const useResourcesStyles = makeStyles(styles);

export default styles;

